import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import './Logistics.scss';
import ShippingSummary from '../../Components/Shipping-Summary/ShippingSummary';
import Geral from '../../Utils/Geral';
import ShippingStatus from '../../Components/ShippingStatus/ShippingStatus';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';

class ShippingDetails extends Component {

    constructor(props) {
        super(props);

        this.getShippingById = this.getShippingById.bind(this);
        this.excluirLocalEntrega = this.excluirLocalEntrega.bind(this);
        this.toggleModalExcluirLocalEntrega = this.toggleModalExcluirLocalEntrega.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            shipping: undefined,
            isLoadingShippingSummary: false
        }
        this.getShippingById();
    }

    async getShippingById() {
        this.setState({ isLoadingShippingSummary: true })
        const _productsList = axios.get(this.Configurations.apiBasePath + `/logistica/remessas/detalhes/${this.props.match.params.idRemessa}`);

        _productsList.then(response => {
            const _shipping = response.data.remessa;

            this.setState({
                shipping: {
                    id: this.props.match.params.idRemessa,
                    items: _shipping.totalItens,
                    products: _shipping.produtos,
                    editions: _shipping.edicoes,
                    deliveryPlaces: _shipping.locaisEntrega,
                    individualDeliveries: _shipping.entregasIndividuais
                },
                isLoadingShippingSummary: false
            });
        }).catch(err => {
            this.handleError(err)
            this.setState({ isLoadingShippingSummary: true });
        });
    }

    excluirLocalEntrega(idLocal) {

        this.setState({ isLoadingExcluirLocalEntrega: true })

        axios.delete(this.Configurations.apiBasePath + `/logistica/local-entrega/${idLocal}/remessa/${this.props.match.params.idRemessa}`).then(response => {
            this.toggleModalExcluirLocalEntrega()
            this.getShippingById()
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingExcluirLocalEntrega: false,
            idLocalEntregaExcluida: null
        }));

    }

    toggleModalExcluirLocalEntrega(id) {
        this.setState({
            idLocalEntregaExcluida: id,
            isOpenModalExcluirLocalEntrega: !this.state.isOpenModalExcluirLocalEntrega
        })
    }

    handleError(err) {
        console.log("Erro inesperado", err);
        this.setState({
            hasError: true, errorMessage: (err.response && err.response.data && !!err.response.data.message) ?
                err.response.data.message : 'Erro inesperado.'
        })
    }

    closeErrorModal() { 
        if(this.state.shipping === undefined){
            this.props.history.goBack()
        } else{
        this.setState({ hasError: false, errorMessage: "" }) 
        }
    }

    render() {
        return (
            <div className="shipping-list logistics">
                <div className="row">
                    <div className="col-8">
                        <h2 className="title-1">Detalhes da remessa</h2>
                    </div>
                    <div className="col-4 text-right">
                        <button className="btn btn-outline-secondary" onClick={() => { this.props.history.goBack() }}>Voltar</button>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <ShippingStatus />
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <ShippingSummary
                            shipping={this.state.shipping}
                            isLoading={this.state.isLoadingShippingSummary}
                            newShippingEvent={this.newShipping}
                            idRemessa={!!this.state.shipping ? this.state.shipping.id : null}
                        />
                    </div>
                </div>

                {this.state.shipping && this.state.shipping.deliveryPlaces.length > 0 && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    Locais de entrega
                                </div>
                                <div className="card-body">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Produtos</th>
                                                <th>Transportadora</th>
                                                <th>Total itens</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.shipping.deliveryPlaces.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{item.localEntrega}</td>
                                                        <td>{item.produtos.map((produto, idx) => (<span key={idx} className={`badge badge-${Geral.badgeProductType(produto)} m-2`}>{produto}</span>))}</td>
                                                        <td>{item.transportadora}</td>
                                                        <td>{item.qtd}</td>
                                                        <td><span className='cursor-pointer' onClick={() => this.toggleModalExcluirLocalEntrega(item.idLocalEntrega)}><i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i></span></td>
                                                    </tr>
                                                )
                                            })}

                                            {this.state.shipping.deliveryPlaces.length === 0 && (
                                                <tr>
                                                    <td colSpan={4}>
                                                        Nenhum local de entrega encontrado
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )
                }

                {this.state.shipping && this.state.shipping.individualDeliveries.length > 0 && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    Lista de clientes
                                </div>
                                <div className="card-body">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Produtos</th>
                                                <th>Transportadora</th>
                                                <th>Total itens</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.shipping.individualDeliveries.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{item.nomeUsuario}</td>
                                                        <td>{item.produtos.map((produto, idx) => (<span key={idx} className={`badge badge-${Geral.badgeProductType(produto)} m-2`}>{produto}</span>))}</td>
                                                        <td>{item.transportadora}</td>
                                                        <td>{item.qtd}</td>
                                                        {/* <td><span className='cursor-pointer' onClick={() => this.toggleModalExcluirLocalEntrega(item.idLocalEntrega)}><i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i></span></td> */}
                                                    </tr>
                                                )
                                            })}

                                            {this.state.shipping.individualDeliveries.length === 0 && (
                                                <tr>
                                                    <td colSpan={4}>
                                                        Nenhum cliente encontrado
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )
                }

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
                <Modal isOpen={this.state.isOpenModalExcluirLocalEntrega} toggle={this.toggleModalExcluirLocalEntrega}>
                    <ModalHeader toggle={this.toggleModalExcluirLocalEntrega}>Excluir local de entrega</ModalHeader>
                    <ModalBody>
                        Deseja realmente excluir local de entrega?
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingExcluirLocalEntrega ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button color="danger" onClick={() => this.excluirLocalEntrega(this.state.idLocalEntregaExcluida)}>Excluir</Button>
                        )}
                        {' '}<Button color="secondary" onClick={this.toggleModalExcluirLocalEntrega}>Cancelar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default ShippingDetails;